import { Box } from '@chakra-ui/react';

import { TextRegular } from 'UiKit/typography';

import styles from './styles.module.css';

const SlotContent = ({ time }) => {
  return (
    <Box className={styles['slot-label-content__container']}>
      <TextRegular className={styles['time-number__text']}>{time?.text}</TextRegular>
    </Box>
  );
};

export default SlotContent;
